import {getAmplitudeDeviceId, getAmplitudeUserId, getResolvedFeatureFlags, waitForAmplitudeInitialization} from "@pg-mono/amplitude";
import type {IDevToolsConfig} from "@pg-mono/devtools";
import {resolveDevtoolsEnabled} from "@pg-mono/devtools";
import {PERFORMANCE_DEBUG_EVENT_NAME, PERFORMANCE_DEBUG_STORAGE_KEY, PERFORMANCE_DEBUG_WINDOW_KEY} from "@pg-mono/performance-debug";
import {TURNSTILE_SIMULATION_CHALLENGE_MODE, TURNSTILE_SIMULATION_FAIL_MODE} from "@pg-mono/turnstile";

import {KM_TURNSTILE_SIMULATION_STORAGE_KEY} from "../features/km_app/constants/storage_keys";
import {CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP, KM_PROTECTED_FORMS_PERFORMANCE_GROUP} from "../features/km_app/performance_debug";
import {amplitudeApiKey, buildImageTag, kmFeatureFlagDevtools} from "../features/km_app/utils/read_environment_variables";

export const initKmDevtools = () => {
    const {isEnabled, isForced} = resolveDevtoolsEnabled(kmFeatureFlagDevtools);

    if (!isEnabled) return;

    void waitForAmplitudeInitialization()
        .catch(() => undefined)
        .then(() => import("@pg-mono/devtools"))
        .then(({initDevTools}) => {
            const config: IDevToolsConfig = {
                isForced,
                buildImageTag,
                amplitude: {
                    isInitialized: Boolean(amplitudeApiKey),
                    apiKeyHint: amplitudeApiKey ? amplitudeApiKey.slice(-4) : undefined,
                    deviceId: getAmplitudeDeviceId(),
                    userId: getAmplitudeUserId()
                },
                amplitudeEvents: [],
                abTests: [],
                featureFlags: Object.values(getResolvedFeatureFlags()),
                envVars: window.__INITIAL_ENV__,
                turnstileSimulation: {
                    storageKey: KM_TURNSTILE_SIMULATION_STORAGE_KEY,
                    modes: [
                        {
                            value: TURNSTILE_SIMULATION_CHALLENGE_MODE,
                            label: "Challenge",
                            description: "Wymusza interaktywny modal challenge na testowym sitekey. Testowy token nie jest wysyłany do API."
                        },
                        {
                            value: TURNSTILE_SIMULATION_FAIL_MODE,
                            label: "Fail",
                            description: "Wymusza modal challenge i odrzuca wysłanie z błędem walidacji Turnstile."
                        }
                    ]
                },
                performanceLogs: {
                    storageKey: PERFORMANCE_DEBUG_STORAGE_KEY,
                    eventName: PERFORMANCE_DEBUG_EVENT_NAME,
                    windowKey: PERFORMANCE_DEBUG_WINDOW_KEY,
                    groups: [
                        {
                            id: CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP,
                            label: "Cloudflare Turnstile",
                            description: "Generowanie, prefetch i dołączanie tokenów Turnstile."
                        },
                        {
                            id: KM_PROTECTED_FORMS_PERFORMANCE_GROUP,
                            label: "KM Protected Forms",
                            description: "Przepływ formularza rejestracji chronionego Turnstile."
                        }
                    ]
                }
            };

            initDevTools(config);
        });
};
import {getAmplitudeDeviceId, getAmplitudeUserId, getResolvedFeatureFlags, waitForAmplitudeInitialization} from "@pg-mono/amplitude";
import type {IDevToolsConfig} from "@pg-mono/devtools";
import {resolveDevtoolsEnabled} from "@pg-mono/devtools";
import {PERFORMANCE_DEBUG_EVENT_NAME, PERFORMANCE_DEBUG_STORAGE_KEY, PERFORMANCE_DEBUG_WINDOW_KEY} from "@pg-mono/performance-debug";
import {TURNSTILE_SIMULATION_CHALLENGE_MODE, TURNSTILE_SIMULATION_FAIL_MODE} from "@pg-mono/turnstile";

import {KM_TURNSTILE_SIMULATION_STORAGE_KEY} from "../features/km_app/constants/storage_keys";
import {CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP, KM_PROTECTED_FORMS_PERFORMANCE_GROUP} from "../features/km_app/performance_debug";
import {amplitudeApiKey, buildImageTag, kmFeatureFlagDevtools} from "../features/km_app/utils/read_environment_variables";

export const initKmDevtools = () => {
    const {isEnabled, isForced} = resolveDevtoolsEnabled(kmFeatureFlagDevtools);

    if (!isEnabled) return;

    void waitForAmplitudeInitialization()
        .catch(() => undefined)
        .then(() => import("@pg-mono/devtools"))
        .then(({initDevTools}) => {
            const config: IDevToolsConfig = {
                isForced,
                buildImageTag,
                amplitude: {
                    isInitialized: Boolean(amplitudeApiKey),
                    apiKeyHint: amplitudeApiKey ? amplitudeApiKey.slice(-4) : undefined,
                    deviceId: getAmplitudeDeviceId(),
                    userId: getAmplitudeUserId()
                },
                amplitudeEvents: [],
                abTests: [],
                featureFlags: Object.values(getResolvedFeatureFlags()),
                envVars: window.__INITIAL_ENV__,
                turnstileSimulation: {
                    storageKey: KM_TURNSTILE_SIMULATION_STORAGE_KEY,
                    modes: [
                        {
                            value: TURNSTILE_SIMULATION_CHALLENGE_MODE,
                            label: "Challenge",
                            description: "Wymusza interaktywny modal challenge na testowym sitekey. Testowy token nie jest wysyłany do API."
                        },
                        {
                            value: TURNSTILE_SIMULATION_FAIL_MODE,
                            label: "Fail",
                            description: "Wymusza modal challenge i odrzuca wysłanie z błędem walidacji Turnstile."
                        }
                    ]
                },
                performanceLogs: {
                    storageKey: PERFORMANCE_DEBUG_STORAGE_KEY,
                    eventName: PERFORMANCE_DEBUG_EVENT_NAME,
                    windowKey: PERFORMANCE_DEBUG_WINDOW_KEY,
                    groups: [
                        {
                            id: CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP,
                            label: "Cloudflare Turnstile",
                            description: "Generowanie, prefetch i dołączanie tokenów Turnstile."
                        },
                        {
                            id: KM_PROTECTED_FORMS_PERFORMANCE_GROUP,
                            label: "KM Protected Forms",
                            description: "Przepływ formularza rejestracji chronionego Turnstile."
                        }
                    ]
                }
            };

            initDevTools(config);
        });
};
